import styled from 'styled-components';
import Button from 'components/Button';

export const AboutContainer = styled.div`
    z-index: 1;
    top: 0px;
    width: 100vw;
    padding: 30px 0px 70px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    color: #D6E1EF;
    @media only screen and (max-width: 768px) {
        padding: 25px 0px 25px 0px;
    }
`;

export const HeadTitle = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #D6E1EF;
    opacity: 0.8;
    margin-bottom: 5px;
`;

export const Title = styled.h1`
    font-family: Khula;
    font-style: normal;
    font-weight: 800;
    font-size: 50px;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: #D6E1EF;
    opacity: 0.8;
    border-bottom: 30px solid transparent;
    @media only screen and (max-width: 768px) {
        font-family: Khula;
        font-style: normal;
        font-weight: 800;
        font-size: 35px;
        line-height: 100%;
        display: flex;
        align-items: center;
        color: #D6E1EF;
        opacity: 0.8;
    }
`;

export const ContainerTypedDesktop = styled.div`
    &>span{
        font-size: 18px;
    }
    @media only screen and (max-width: 768px) {
        display: none;
    }
`;

export const ContainerTypedPhone = styled.div`
    @media only screen and (min-width: 768px) {
        display: none;
    }
    @media only screen and (max-width: 768px) {
        margin-top: 30px;
        min-height: 220px;
        &>span{
            font-size: 13px;
        }
    }
`;

export const Description = styled.h3`
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: #D6E1EF;
    opacity: 0.8;
    @media only screen and (max-width: 768px) {
        font-family: Khula;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 100%;
        display: flex;
        align-items: center;
        color: #D6E1EF;
    }
`;

export const CallToAction = styled(Button)`
    margin: 50px 0px;
    @media only screen and (max-width: 768px) {
        margin-top: 25px;
    }
`;

export const CellImageUp = styled.img`
    @media only screen and (max-width: 768px) {
        display: none;
    }
    @media only screen and (min-width: 768px) {
        position: absolute;
        transform: rotate(180deg);
        transform: rotateX(180deg);
        top: -130px;
        right: 5%;
        width: 200px;
    }
    @media only screen and (min-width: 992px) {
        right: 10%;
        width: 210px;
    }
    @media only screen and (min-width: 1200px) {
        right: 15%;
        width: 220px;
    }
    @media only screen and (min-width: 1500px) {
        right: 25%;
        width: 239px;
    }
`;

export const CellImageDown = styled.img`
    @media only screen and (max-width: 768px) {
        display: none;
    }
    @media only screen and (min-width: 768px) {
        position: absolute;
        bottom: -150px;
        left: 5%;
        width: 200px;
    }
    @media only screen and (min-width: 992px) {
        left: 10%;
        width: 210px;
    }
    @media only screen and (min-width: 1200px) {
        left: 15%;
        width: 220px;
    }
    @media only screen and (min-width: 1500px) {
        left: 25%;
        width: 239px;
    }
`;